import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=5c3602f2&scoped=true"
import script from "./simple.vue?vue&type=script&lang=js"
export * from "./simple.vue?vue&type=script&lang=js"
import style0 from "./simple.vue?vue&type=style&index=0&id=5c3602f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3602f2",
  null
  
)

export default component.exports